import { render, staticRenderFns } from "./SVGStepsProjects.vue?vue&type=template&id=150b8a9a&scoped=true&"
import script from "./SVGStepsProjects.vue?vue&type=script&lang=js&"
export * from "./SVGStepsProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150b8a9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('150b8a9a')) {
      api.createRecord('150b8a9a', component.options)
    } else {
      api.reload('150b8a9a', component.options)
    }
    module.hot.accept("./SVGStepsProjects.vue?vue&type=template&id=150b8a9a&scoped=true&", function () {
      api.rerender('150b8a9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGStepsProjects.vue"
export default component.exports